import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useRef } from "react";
export default function useMasonry() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [items, setItems] = useState(t0);
  const masonryContainer = useRef(null);
  const elementLeft = _temp;
  const elementTop = _temp2;
  const elementBottom = _temp3;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (masonryContainer.current) {
        const masonryItem = Array.from(masonryContainer.current.children);
        setItems(masonryItem);
      }
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== items) {
    t3 = () => {
      const handleMasonry = () => {
        if (!items || items.length < 1) {
          return;
        }
        let gapSize = 0;
        if (masonryContainer.current) {
          gapSize = parseInt(window.getComputedStyle(masonryContainer.current).getPropertyValue("grid-row-gap"));
        }
        items.forEach(el_2 => {
          if (!(el_2 instanceof HTMLElement)) {
            return;
          }
          let previous = el_2.previousSibling;
          while (previous) {
            if (previous.nodeType === 1) {
              el_2.style.marginTop = "0";
              if (previous instanceof HTMLElement && elementLeft(previous) === elementLeft(el_2)) {
                el_2.style.marginTop = -(elementTop(el_2) - elementBottom(previous) - gapSize) + "px";
                break;
              }
            }
            previous = previous.previousSibling;
          }
        });
      };
      handleMasonry();
      window.addEventListener("resize", handleMasonry);
      return () => {
        window.removeEventListener("resize", handleMasonry);
      };
    };
    t4 = [items];
    $[3] = items;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return masonryContainer;
}
function _temp3(el_1) {
  return el_1.getBoundingClientRect().bottom + window.scrollY;
}
function _temp2(el_0) {
  return el_0.getBoundingClientRect().top + window.scrollY;
}
function _temp(el) {
  return el.getBoundingClientRect().left;
}